import { useState } from 'react';
import { ChatLightbox } from '../../adminPages/Chat/components/ChatLightbox';
import { Modal } from '../../components';
import { useDisableBodyScroll } from '../../helpers';
import { Img } from '../../styles';

export const ImagePreview = ({
  image,
  style,
  header,
  borderRadius,
  ToggleComponent,
  width,
  footer,
  isOpen: controlledIsOpen,
  closeModal: controlledClose,
  hideTrigger,
  zIndex,
  modalWidth,
  lightbox,
}: {
  image: string | null;
  style?: React.CSSProperties;
  header?: string;
  borderRadius?: string;
  ToggleComponent?: (onClick: () => void) => React.ReactNode;
  width?: string;
  // Optional sticky footer (e.g. action buttons) rendered in the preview modal.
  footer?: React.ReactNode;
  // Controlled mode: when `isOpen` is provided the parent owns open/close (and
  // usually pairs it with `hideTrigger` so no inline thumbnail is rendered).
  // Omit it and the component self-manages open state via the thumbnail/toggle.
  isOpen?: boolean;
  closeModal?: () => void;
  hideTrigger?: boolean;
  zIndex?: number;
  modalWidth?: string;
  /**
   * Open the image full screen in the chat's lightbox instead of the modal.
   * `header`, `footer`, `zIndex` and `modalWidth` belong to the modal and are
   * ignored then. The lightbox sits above the app's modals, so it also works
   * from a thumbnail inside one.
   */
  lightbox?: boolean;
}) => {
  const [internalOpen, setInternalOpen] = useState(false);

  const controlled = controlledIsOpen !== undefined;
  const isOpen = controlled ? controlledIsOpen : internalOpen;
  const close = controlled
    ? controlledClose ?? (() => undefined)
    : () => setInternalOpen(false);

  useDisableBodyScroll(isOpen);

  return (
    <>
      {!hideTrigger &&
        (ToggleComponent ? (
          ToggleComponent(() => setInternalOpen(true))
        ) : (
          <Img
            alt=""
            src={image ?? ''}
            $width={width || '100%'}
            onClick={() => setInternalOpen(true)}
            style={{ ...style, cursor: 'pointer' }}
            $borderRadius={borderRadius}
          />
        ))}

      {lightbox ? (
        <ChatLightbox
          images={image ? [{ id: image, url: image }] : []}
          index={isOpen ? 0 : null}
          onIndex={() => undefined}
          onClose={close}
        />
      ) : (
        <Modal
          width={modalWidth ?? '80vw'}
          logo={false}
          isOpen={isOpen}
          closeModal={close}
          header={header}
          footer={footer}
          zIndex={zIndex}
          $numOfFloatingButtons={footer ? 1 : undefined}
        >
          <Img alt="" src={image ?? ''} $maxWidth="100%" $maxHeight="65vh" />
        </Modal>
      )}
    </>
  );
};
